export default "__VITE_ASSET__CKgFT6p$__"